import {createFeatureSelector, createSelector} from '@ngrx/store';
import {HttpActionState} from '../../../../users/userslisting/store/users-listing.reducers';
import {documentsBulkUploadConfig} from './documents-bulk-upload.config';
import {IDocumentsBulkUploadState} from './documents-bulk-upload.reducers';

export const state = createFeatureSelector<IDocumentsBulkUploadState>(documentsBulkUploadConfig);

export const uploadId = createSelector(state, state => state.uploadId);
export const currentStep = createSelector(state, state=> state.currentStep);
export const firstLineTitles = createSelector(state, state=> state.firstLineTitles);

export const previewData = createSelector(state,state =>state.previewData);
export const previewColumns = createSelector(state,state =>state.previewColumns)
export const mergeOrganisations = createSelector( state, state=>state.merge_organisations);

export const importedSummary  = createSelector( state, state=>state.importedSummary);
export const unimportedSummary = createSelector( state, state=>state.unimported);
export const failedImports = createSelector(state, state => state.failedImports);
 
export const uploadedFiles=  createSelector(state, state => state.uploadedFiles);

export const firstRowData =  createSelector(state, state => state.firstRow);
export const cardColumns=  createSelector(state, state => state.cardColumns);
export const mapping =  createSelector(state, state => state.mapping);


/* loading masks */
export const isUpdateMappingRequestInProgress = createSelector(state, state => state.isUpdateMappingRequestInProgress === HttpActionState.Busy);
export const isSkipStepLoading = createSelector(state, state => state.isSkipStepLoading === HttpActionState.Busy);
export const isFirstLineLoading = createSelector(state, state => state.isFirstLineLoading === HttpActionState.Busy);
export const isPotentialMappingLoading = createSelector(state, state => state.isPotentialMappingLoading === HttpActionState.Busy);

export const importSettings= createSelector(state, state=>state.importSettings);
